module.exports = __webpack_public_path__ + "img/arr-back.c0a17a47.svg";